export const GET_ABM = "GET_ABM";
export const GET_ABM_SUCCESS = "GET_ABM_SUCCESS";
export const GET_ABM_FAIL = "GET_ABM_FAIL";


export const POST_ABM = "POST_ABM";
export const POST_ABM_SUCCESS = "POST_ABM_SUCCESS";
export const POST_ABM_FAIL = "POST_ABM_FAIL";

export const PUT_ABM = "PUT_ABM";
export const PUT_ABM_SUCCESS = "PUT_ABM_SUCCESS";
export const PUT_ABM_FAIL = "PUT_ABM_FAIL";

export const DELETE_ABM = "DELETE_ABM";
export const DELETE_ABM_SUCCESS = "DELETE_ABM_SUCCESS";
export const DELETE_ABM_FAIL = "DELETE_ABM_FAIL";


export const SELECTED_ITEM = "SELECTED_ITEM"; 
export const ALL_SELECTED_ITEM = "ALL_SELECTED_ITEM"; 

